module.exports = __webpack_public_path__ + "img/terminos_y_condiciones-02.8f8bb595.webp";